import { Capacitor, registerPlugin } from '@capacitor/core';
export const isNativeIOS = () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
export const NATIVE_API_ORIGIN = 'https://goopa.volinodesign.workers.dev';
export let nativeDemo = false;
export const setNativeDemo = (value: boolean) => { nativeDemo = value; };
export const NativeRuntime = registerPlugin<{ info(): Promise<{ demo: boolean; demoSupported: boolean; live: boolean; pushEnvironment: "sandbox" | "production" }> }>('GoopaRuntime');
